import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";
import InvoiceActivityCardContent from "./InvoiceActivityCardContent";
import moment from "moment";

interface Props {
  activity: server.dto.InvoiceActivity
}

const displayRemoteAddressActions: server.dto.InvoiceActions[] = [
  "accessedInvitation",
  "linkToUser"
];

const InvoiceActivityCard = (props: Props) => {
  const { lifeCycle, timestampUtc, action } = props.activity;

  const timstampUtcMoment = moment.utc(timestampUtc);

  let cardColor;

  switch (lifeCycle) {
    case "draft":
      cardColor = "gray-dark";
      break;
    case "review":
      cardColor = "purple";
      break;
    case "pending":
      cardColor = "orange";
      break;
    case "completed":
      cardColor = "green";
      break;
    case "discarded":
      cardColor = "gray";
      break;
    default:
      break;
  };

  const subtitles = [timstampUtcMoment.fromNow()];
  if (displayRemoteAddressActions.includes(action.value)) {
    subtitles.push(props.activity.remoteAddress);
  }
  return <ActivityCard
    activity={props.activity}
    cardColor={cardColor}
    overrideSubtitle={() => subtitles}
  >
    <InvoiceActivityCardContent activity={props.activity} />
  </ActivityCard>;
};

export default InvoiceActivityCard;